export class JobStatusCount {
    constructor() {
    }

    public appliedJobs: number = 0;
    public savedJobs: number = 0;
    public viewedJobs: number = 0;
    public invitedJobs: number = 0;
    public inProgressJobs: number = 0;
    public finishedJobs: number = 0;

}
